var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPjbegleiter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09 9.332l6.332 3.576a.95.95 0 00.935 0l6.331-3.576m-13.598 0l-1.626-.919a.95.95 0 010-1.654l7.958-4.495a.95.95 0 01.935 0l7.957 4.495a.95.95 0 010 1.654l-1.626.919m-13.598 0v6.381c0 .347.19.667.494.833l5.849 3.204a.95.95 0 00.913 0l5.849-3.204a.95.95 0 00.493-.833V9.332",
    strokeWidth: 2.5
  })));
}
export default SvgPjbegleiter;